import React, { useEffect, useState } from "react";
import { IWellnessPlanByUser } from "../../../services/wellness-plans-by-user/wellness-plan-by-user.interface";
import AssignPaymentPetCard from "./AssignPaymentPetCard";
import { FormControl, FormControlLabel, Radio } from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface IAssignPaymentPetCardList {
  wellnessPaymentData: IWellnessPlanByUser[];
  setUpdateWellnessIds?: (wellnessIds: string[]) => void;
}

const AssignPaymentPetCardList = ({
  wellnessPaymentData,
  setUpdateWellnessIds,
}: IAssignPaymentPetCardList) => {
  const [selectedWellnessIds, setSelectedWellnessIds] = useState<string[]>([]);

  const displayWellnessPaymentData = wellnessPaymentData.filter((plan) => {
    const wellnessIdStr = (plan.wellnessPlanDetails?.wellnessId ?? "").toString().trim();
    const wellnessIdNum = Number(wellnessIdStr);
    const isZeroOrInvalidWellnessId = wellnessIdStr.length === 0 || Number.isNaN(wellnessIdNum) || wellnessIdNum === 0;
    // Hide non-ScratchPay placeholder plans (wellnessId=0).
    // Hide plans with missing subscriptionId to prevent assigning
    // cards to non-existing subscriptions.
    const isMissingSubscriptionId = !plan.subscriptionId;
    return !isZeroOrInvalidWellnessId && !isMissingSubscriptionId;
  });

  const handlePetCardSelection = (petWellnessId: string) => {
    setSelectedWellnessIds((prevSelectedWellnessIds) =>
      prevSelectedWellnessIds.includes(petWellnessId) ?
        prevSelectedWellnessIds.filter((wellnessId) => wellnessId !== petWellnessId) :
        [...prevSelectedWellnessIds, petWellnessId],
    );
  };

  useEffect(() => {
    setUpdateWellnessIds && setUpdateWellnessIds(selectedWellnessIds);
  }, [selectedWellnessIds]);

  return (
    <FormControl className="w-full flex flex-col gap-3">
      {displayWellnessPaymentData.map((petWellnessDetails, index) => {
        const wellnessId = petWellnessDetails.wellnessPlanDetails.wellnessId.toString();
        const isScratchpay = !!petWellnessDetails.isScratchpay;
        const isSelected = selectedWellnessIds.includes(wellnessId);
        return (<div key={petWellnessDetails.subscriptionId || wellnessId}>
          <FormControlLabel
            key={index}
            value={wellnessId}
            disabled={isScratchpay}
            control={
              <Radio
                checked={isSelected}
                disabled={isScratchpay}
                icon={
                  <RadioButtonUncheckedIcon
                    sx={{ color: "gray", fontSize: 26 }}
                  />
                }
                checkedIcon={
                  <CheckCircleIcon
                    sx={{ color: "#7588DF", fontSize: 26 }}
                  />
                }
              />
            }
            onClick={isScratchpay ? undefined : () => handlePetCardSelection(wellnessId)}
            label={
              <AssignPaymentPetCard
                petWellnessDetails={petWellnessDetails}
                onClick={handlePetCardSelection}
                isDisabled={isScratchpay}
              />
            }
            className={`w-full bg-white rounded-xl p-2 border cursor-pointer !ml-0
              ${
          isScratchpay ?
            "opacity-60 cursor-not-allowed border-taupe-50" :
            isSelected ?
              "!bg-violet-3 border-violet-2" :
              "border-taupe-50 hover:bg-violet-3 hover:border-violet-2"
          }`}
          />
        </div>);
      })}
    </FormControl>
  );
};

export default AssignPaymentPetCardList;
